import { getBrowserSubVersion } from "../../../utility/testHelpers";
import {
  isCDPTest,
  isNewAnnotationFlowEnabled
} from "../../../utility/utilityFunctions";
import { LAMBDATEST_CLEAR_BROWSER_SUBVERSION } from "../../actionTypeConstants/LambdaTestTestDetailConstants";
import {
  FETCH_COMMAND_LOG_COUNT_SUCCESS,
  LAMBDATEST_ADD_CDP_REQUEST_LOGS_SSE,
  LAMBDATEST_ALL_COMMAND,
  LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_FAILED,
  LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_LOADING,
  LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_SUCCESS,
  LAMBDATEST_REQUEST_DATA_CLEAR,
  LAMBDATEST_REQUEST_FAILED,
  LAMBDATEST_ADD_SANITIZED_COMMANDS,
  LAMBDATEST_REQUEST_INFINITE_FAILED,
  LAMBDATEST_REQUEST_INFINITE_LOADING,
  LAMBDATEST_REQUEST_INFINITE_SILENT_LOADING,
  LAMBDATEST_REQUEST_INFINITE_SUCCESS,
  LAMBDATEST_REQUEST_LOADING,
  LAMBDATEST_REQUEST_SUCCESS,
  LAMBDATEST_UPDATE_COMMAND_RERUN_EXECUTION_STATUS,
  LAMBDATEST_REPLACE_COMMAND_LOGS_SSE,
  SET_EXPANDED_ANNOTATIONS,
  SET_EXPANDED_COMMAND_LOGS
} from "../../actionTypeConstants/ml2.0/CommandLogs";

import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import isObject from "lodash/isObject";

const initialState = {
  browserSubVersion: "",
  currentPageOffset: 0,
  commandLogPageCount: null,
  allCommands: [],
  timestamp: [],
  data: [],
  sanitizedCommandLogs: [],
  hasMore: false,
  loading: true,
  pageDetails: [],
  silentLoading: false,
  error: null,
  total: null,
  from: null,
  dataSource: null,
  logType: null,
  size: null,
  wasabiEnabled: false,
  isPageStartTime: false,
  loadedPage: [],
  annotationLoadedPages: {},
  frameworkExceptionLoading: true,
  frameworkExceptionData: [],
  frameworkExceptionError: null,
  expandedAnnotations: {},
  expadedCommandLogs: {}
};

const getAnnotationCommandLogs = ({
  state,
  startIndex,
  annotationIndex,
  isUpdatedCount,
  data
}) => {
  let sanitizedCommandLogs = state.allCommands ? [...state.allCommands] : [];
  if (isUpdatedCount) {
    sanitizedCommandLogs = new Array(data.length).fill(null);
  }

  const list = state.allCommands[annotationIndex]?.list
    ? [...state.allCommands[annotationIndex].list]
    : [];
  for (let i = 0; i < data.length; i++) {
    if (startIndex + i < list.length) {
      list[startIndex + i] = data[i];
    }
  }
  sanitizedCommandLogs[annotationIndex] = {
    ...sanitizedCommandLogs[annotationIndex],
    list: [...list]
  };
  return sanitizedCommandLogs;
};

const getCommandlogs = ({
  state,
  startIndex,
  data,
  testDetails,
  annotationIndex,
  isUpdatedCount
}) => {
  let logs = state.allCommands ? [...state.allCommands] : [];
  if (isUpdatedCount) {
    logs = new Array(data.length).fill(null);
  }
  const value = isCDPTest(testDetails?.type) ? `value` : "Value";

  for (let i = 0; i < data.length; i++) {
    if (startIndex + i < logs.length) {
      logs[startIndex + i] = data[i];
      if (data[i]?.Value?.annotationId) {
        logs[startIndex + i] = {
          ...logs[startIndex + i],
          list: new Array(
            state.annotationsData?.[data[i]?.Value?.annotationId]
              ?.commandCount || 0
          ).fill(null)
        };
      }
    }
  }
  return logs.sort((a, b) => {
    const commandA = a?.[value]?.requestStartTime;
    const commandB = b?.[value]?.requestStartTime;
    if (!commandA) {
      return 0;
    }
    if (commandA < commandB) return -1;
    if (commandA > commandB) return 1;
    return 0;
  });
};

const getTimeStamps = ({
  state,
  startIndex,
  data,
  testDetails,
  annotationIndex,
  annotationId,
  isUpdatedCount
}) => {
  let logs = state.timestamp ? [...state.timestamp] : [];
  if (isUpdatedCount) {
    logs = new Array(data.length).fill(null);
  }
  const value = isCDPTest(testDetails?.type) ? `value` : "Value";
  if (annotationIndex >= 0) {
    if (!isObject(logs[annotationIndex])) {
      let _list = new Array(
        state.annotationsData?.[annotationId]?.commandCount || 0
      ).fill(null);
      const annotationPages = state.annotationsData?.[annotationId]?.pages;

      _list = _list.map((value, index) => {
        const pageNumber = Math.floor(index / 100);
        return Number(annotationPages[pageNumber].startTime);
      });

      logs[annotationIndex] = {
        timestamp: logs[annotationIndex],
        list: _list
      };

      for (let i = 0; i < data.length; i++) {
        if (startIndex + i < logs[annotationIndex]?.list?.length) {
          logs[annotationIndex].list[startIndex + i] =
            data?.[i][value].requestStartTime;
        }
      }
    } else {
      for (let i = 0; i < data.length; i++) {
        if (startIndex + i < logs[annotationIndex]?.list?.length) {
          logs[annotationIndex].list[startIndex + i] =
            data?.[i][value].requestStartTime;
        }
      }
    }

    return logs;
  } else {
    for (let i = 0; i < data.length; i++) {
      const value = isCDPTest(testDetails?.type) ? `value` : "Value";
      if (startIndex + i < logs.length) {
        logs[startIndex + i] = data?.[i][value].requestStartTime || null;
      }
    }
    return logs.sort((timestampA, timestampB) => {
      if (!timestampA) {
        return 0;
      }
      if (timestampA < timestampB) return -1;
      if (timestampA > timestampB) return 1;
      return 0;
    });
  }
};

const getAnnotationLoadedPages = ({ state, pageNumber, annotationId }) => {
  const annotationLoadedPages = state.annotationLoadedPages;
  if (annotationLoadedPages?.[annotationId]) {
    annotationLoadedPages[annotationId].push(pageNumber);
  } else {
    annotationLoadedPages[annotationId] = [pageNumber];
  }
  return annotationLoadedPages;
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_REQUEST_INFINITE_LOADING: {
      return {
        ...state,
        data: [],
        allCommands: [],
        loading: true,
        silentLoading: false,
        error: null
      };
    }

    case SET_EXPANDED_ANNOTATIONS: {
      return {
        ...state,
        expandedAnnotations: {
          ...state.expandedAnnotations,
          [action.payload.index]:
            typeof action.payload.value === "boolean"
              ? action.payload.value
              : !state.expandedAnnotations[action.payload.index]
        }
      };
    }

    case SET_EXPANDED_COMMAND_LOGS: {
      const { annotationIndex, commandIndex } = action.payload;
      const data = !annotationIndex
        ? {
            [commandIndex]: !state.expadedCommandLogs?.[commandIndex]
          }
        : {
            [annotationIndex]: {
              ...state.expadedCommandLogs?.[annotationIndex],
              [commandIndex]: !state.expadedCommandLogs?.[annotationIndex]?.[
                commandIndex
              ]
            }
          };

      return {
        ...state,
        expadedCommandLogs: {
          ...state.expadedCommandLogs,
          ...data
        }
      };
    }

    case LAMBDATEST_ALL_COMMAND: {
      const { payload } = action;
      return {
        ...state,
        allCommands: new Array(payload || 0).fill(null)
      };
    }

    case LAMBDATEST_REQUEST_INFINITE_SUCCESS: {
      const {
        isCDPRetryCall = false,
        isCDPTest = false,
        isDesktopTest = false,
        isFetchFromLTMA = false,
        isRealMobile = false,
        pageNumber,
        filters,
        isMobileCmdLogV2Enabled,
        testDetails,
        isAnnotation,
        annotationIndex,
        annotationId,
        isContextFilterApplied
      } = action.payload;

      const { pageChunkSize } = action.payload;
      let hasMore = true;
      const logListDataObj =
        (isFetchFromLTMA && !isRealMobile) ||
        (isFetchFromLTMA && isRealMobile && isMobileCmdLogV2Enabled)
          ? get(action, "result", [])
          : get(action, ["result", "data"], []);

      if (get(logListDataObj, "data", []).length < pageChunkSize) {
        hasMore = false;
      }
      const valueKeyInsideLogListDataObj = isCDPTest ? "value" : "Value";
      const matchingCommands = logListDataObj.data.filter(log => {
        const { requestPath, responseStatus } = log[
          valueKeyInsideLogListDataObj
        ];
        return requestPath === "/wd/hub/session" && responseStatus === "200 OK";
      });
      let browserSubVersion = "";
      if (matchingCommands.length) {
        browserSubVersion = getBrowserSubVersion({
          command: matchingCommands[0],
          isDesktopTest
        });
      }

      if (
        (isFetchFromLTMA && !isRealMobile) ||
        (isFetchFromLTMA && isRealMobile && isMobileCmdLogV2Enabled)
      ) {
        hasMore = state.commandLogPageCount - 1 > pageNumber;
      }

      // TODO (vasuarora21): Condition to be changed when all filters will be appended in url
      if (!isEmpty(filters)) {
        hasMore = false;
      }

      const alreadyPresentData = state.data;

      const updatedLogList = [...alreadyPresentData, ...logListDataObj.data];

      const startIndex =
        !isMobileCmdLogV2Enabled && isRealMobile
          ? 0
          : pageNumber * pageChunkSize;

      const isNewAnnotationFlow = isNewAnnotationFlowEnabled(testDetails);
      const isUpdatedCount = isContextFilterApplied && isNewAnnotationFlow;

      if (isAnnotation) {
        return {
          ...state,
          allCommands: getAnnotationCommandLogs({
            state,
            data: logListDataObj.data,
            annotationIndex,
            startIndex,
            isUpdatedCount
          }),
          timestamp: getTimeStamps({
            state,
            startIndex,
            data: logListDataObj.data,
            testDetails,
            annotationIndex,
            annotationId: annotationId,
            isUpdatedCount
          }),
          anotationLoadedPages: getAnnotationLoadedPages({
            state,
            pageNumber,
            annotationId
          })
        };
      }

      return {
        ...state,
        data: updatedLogList,
        hasMore: hasMore,
        loading: updatedLogList.length ? false : isCDPRetryCall,
        silentLoading: false,
        browserSubVersion,
        currentPageOffset: pageNumber,
        loadedPage: [...state.loadedPage, pageNumber],
        allCommands: getCommandlogs({
          state,
          startIndex,
          data: logListDataObj.data,
          testDetails,
          isUpdatedCount
        }),
        timestamp: getTimeStamps({
          state,
          startIndex,
          data: logListDataObj?.data,
          testDetails,
          isUpdatedCount
        }),
        total: logListDataObj.total,
        dataSource: logListDataObj.dataSource,
        from: logListDataObj.from,
        logType: logListDataObj.logType,
        size: logListDataObj.size,
        wasabiEnabled: logListDataObj.wasabiEnabled
      };
    }

    case LAMBDATEST_REQUEST_INFINITE_FAILED: {
      return {
        ...state,
        loading: false,
        silentLoading: false,
        error: action.error
      };
    }

    case LAMBDATEST_REQUEST_INFINITE_SILENT_LOADING: {
      return {
        ...state,
        loading: false,
        silentLoading: true
      };
    }

    case LAMBDATEST_REQUEST_LOADING: {
      return {
        ...state,
        loading: true,
        silentLoading: false
      };
    }

    case LAMBDATEST_REQUEST_SUCCESS: {
      const {
        isDemoTest = false,
        isFetchFromLTMA = false,
        testType = "desktop",
        isMobileCmdLogV2Enabled,
        isRealMobile,
        pageChunkSize,
        pageNumber,
        testDetails
      } = action.payload;
      let dataObj = isFetchFromLTMA
        ? testType === "realMobile"
          ? get(action, ["result", "data"], [])
          : get(action, ["result"], [])
        : testType === "realMobile"
        ? get(action, ["result", "data", "data"], [])
        : get(action, ["result", "data"], []);
      if (isDemoTest) {
        dataObj = get(action, ["result", "data", "data"], []);
      }
      const startIndex =
        !isMobileCmdLogV2Enabled && isRealMobile
          ? 0
          : pageNumber * pageChunkSize;

      return {
        ...state,
        data: dataObj,
        allCommands: getCommandlogs({
          state,
          startIndex,
          data: dataObj,
          testDetails
        }),
        timestamp: getTimeStamps({
          state,
          startIndex,
          data: dataObj,
          testDetails
        }),
        loading: false,
        silentLoading: false
      };
    }

    case LAMBDATEST_REQUEST_FAILED: {
      return {
        ...state,
        data: [],
        allCommands: [],
        timestamp: [],
        loading: false,
        silentLoading: false,
        error: action.error
      };
    }

    case LAMBDATEST_REQUEST_DATA_CLEAR: {
      return {
        ...state,
        data: [],
        sanitizedCommandLogs: [],
        allCommands: [],
        expadedCommandLogs: {},
        expandedAnnotations: {},
        loadedPages: [],
        annotationLoadedPages: {},
        timestamp: [],
        loadedPage: [],
        loading: false,
        error: null
      };
    }

    case FETCH_COMMAND_LOG_COUNT_SUCCESS: {
      const pageCount = get(action, ["result", "data", "data"], []).length;
      const data = get(action, ["result", "data", "data"], []);
      const annotationsData = get(
        action,
        ["result", "data", "annotations"],
        []
      );
      const pageDetails = [];
      const pageChunkSize = action.pageChunkSize;
      const testDetails = action.testDetails;
      data.forEach((page, index) => {
        if (page.page_start_time) {
          pageDetails[index] = page.page_start_time || null;
        }
      });
      const _timeStamp = new Array(testDetails?.commandCount || 0).fill(null);
      const timestampList = _timeStamp.map((value, index) => {
        const pageNumber = Math.floor(index / (pageChunkSize || 20));
        return Number(pageDetails[pageNumber]);
      });

      const isPageStartTime = pageDetails.findIndex(timestamp => {
        if (timestamp) {
          return true;
        }
      });
      return {
        ...state,
        loadedPage: [],
        annotationLoadedPages: {},
        expadedCommandLogs: {},
        expandedAnnotations: {},
        annotationsData: annotationsData,
        commandLogPageCount: pageCount,
        isPageStartTime: isPageStartTime,
        timestamp: [...timestampList],
        pageDetails: pageDetails
      };
    }

    case LAMBDATEST_CLEAR_BROWSER_SUBVERSION: {
      return {
        ...state,
        browserSubVersion: ""
      };
    }

    case LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_LOADING: {
      return {
        ...state,
        frameworkExceptionLoading: true
      };
    }

    case LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_SUCCESS: {
      return {
        ...state,
        frameworkExceptionLoading: false,
        frameworkExceptionData: action.result.data,
        frameworkExceptionError: null
      };
    }

    case LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_FAILED: {
      return {
        ...state,
        frameworkExceptionLoading: false,
        frameworkExceptionError: action.error
      };
    }

    case LAMBDATEST_ADD_CDP_REQUEST_LOGS_SSE: {
      const updatedLogs = isArray(action.payload)
        ? [...state.data, ...action.payload]
        : [...state.data, action.payload];
      return {
        ...state,
        data: updatedLogs,
        loading: false,
        silentLoading: false
      };
    }

    case LAMBDATEST_ADD_SANITIZED_COMMANDS: {
      const sanitizedCommandLogs = action.payload || [];
      return {
        ...state,
        sanitizedCommandLogs: sanitizedCommandLogs
      };
    }

    case LAMBDATEST_REPLACE_COMMAND_LOGS_SSE: {
      const commandLogsList = state.sanitizedCommandLogs || [];
      const commandLogsListCopy = [...commandLogsList];

      let currentCommandRequestId;

      const { event, data } = action.payload || {};

      const executingCommandData = data || [];

      executingCommandData.forEach((item, index) => {
        const currentExecutingCommand = item;

        if (event === "CommandLogStarted") {
          currentCommandRequestId = currentExecutingCommand?.linkedRequestId;
        } else if (event === "CommandLog") {
          currentCommandRequestId =
            currentExecutingCommand?.value?.linkedTestRequestId;
        }

        const commandLogsListIndex = commandLogsList.findIndex(log => {
          return log?.value?.requestId === currentCommandRequestId;
        });

        if (commandLogsListIndex !== -1) {
          // resetting the isCmdExecuted for all commands after the current executing command
          if (
            commandLogsListCopy[commandLogsListIndex - 1] &&
            !commandLogsListCopy[commandLogsListIndex - 1]?.isCmdExecuted
          ) {
            // assuming the previous commands are executed
            commandLogsListCopy.slice(0, commandLogsListIndex).forEach(item => {
              item["isCmdExecuted"] = true;
            });
          }

          if (event === "CommandLogStarted") {
            commandLogsListCopy[commandLogsListIndex] = {
              ...commandLogsListCopy[commandLogsListIndex],
              isLiveCommand: index === executingCommandData.length - 1 // mark live command only for the last idx
            };
          } else if (event === "CommandLog") {
            // adding indicator to show the current executing command log
            commandLogsListCopy[commandLogsListIndex] = {
              ...currentExecutingCommand,
              isLiveCommand: false,
              isCmdExecuted: true
            };
          }
        }
      });

      return {
        ...state,
        sanitizedCommandLogs: commandLogsListCopy
      };
    }

    case LAMBDATEST_UPDATE_COMMAND_RERUN_EXECUTION_STATUS: {
      return {
        ...state,
        sanitizedCommandLogs: action.payload
      };
    }

    default: {
      return state;
    }
  }
}
